import { createContext } from 'react';

import type { XYChartVisibleAxesConfig } from '../../types/xy-chart-internals.js';

export const XYChartVisibleAxesConfigContext = createContext<
  XYChartVisibleAxesConfig | undefined
>(undefined);
